import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';
import { _ as _objectWithoutProperties } from '../objectWithoutProperties-DN7d1SzH.js';
import { CURRENT_LANGUAGE_COOKIE_NAME } from '../configs/constants/index.js';
import { getCookie } from '../cookie/index.js';
import getDeviceId from '../getDeviceId/index.js';

var _excluded = ["withoutDeviceId", "withoutLanguageHeader"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetchWithTimeout = function fetchWithTimeout(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    withoutDeviceId = _ref.withoutDeviceId,
    withoutLanguageHeader = _ref.withoutLanguageHeader,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!withoutLanguageHeader) {
    var currentLangauge = getCookie(CURRENT_LANGUAGE_COOKIE_NAME);
    rest.headers = _objectSpread(_objectSpread({}, rest.headers), {}, {
      'language-code': currentLangauge
    });
  }
  if (!withoutDeviceId) {
    rest.headers = _objectSpread(_objectSpread({}, rest.headers), getDeviceId() && {
      deviceid: getDeviceId()
    });
  }
  return fetch(url, _objectSpread({}, rest));
};

export { fetchWithTimeout as default };
//# sourceMappingURL=index.js.map
